var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 89,
    viewBox: "0 0 103 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.036 41.9773L78.6105 2.09259C77.8441 0.795195 76.4382 0 74.947 0H28.0952C26.5624 0 25.1565 0.795195 24.3902 2.09259L0.964234 41.9773C0.196818 43.2747 0.196818 44.8651 0.964234 46.1625L24.3902 86.0474C25.1565 87.3448 26.5624 88.14 28.0952 88.14H74.947C76.4382 88.14 77.8441 87.3448 78.6105 86.0474L102.036 46.1625C102.803 44.8651 102.803 43.2747 102.036 41.9773ZM51.5211 66.67C38.8286 66.67 28.5215 56.5419 28.5215 44.0699C28.5215 31.5981 38.8286 21.47 51.5211 21.47C64.171 21.47 74.4791 31.5981 74.4791 44.0699C74.4791 56.5419 64.171 66.67 51.5211 66.67Z",
    fill: "#F1EEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord10);
export default __webpack_public_path__ + "static/media/accord_10.16a290012f1fe18155741a3a4c5be3b5.svg";
export { ForwardRef as ReactComponent };